import ApiKeys, { IApiKeyProps, IApiKeyActions } from "./api-kyes";
import { connect } from "react-redux";
import { IUser } from "@common/models";
import {
  updateUserApiKey,
  deleteUserApiKey,
  createUserApiKey
} from "../../admin.actions";

export default connect(
  (_, { userId, apiKeys }: IUser): IApiKeyProps => ({
    userId,
    apiKeys
  }),
  (dispatch): IApiKeyActions => ({
    updateApiKeys: (
      userId: string,
      newDate: string,
      newName: string,
      oldName: string
    ) => dispatch(updateUserApiKey(userId, newDate, newName, oldName)),
    deleteApiKey: (userId: string, tokenName: string) =>
      dispatch(deleteUserApiKey(userId, tokenName)),
    createApiKey: (userId: string) => dispatch(createUserApiKey(userId))
  })
)(ApiKeys);
